import { lwfRequest } from "pages/PayRoll/Configuration/StatutoryConfiguration/LWF/lwfConfigApi";

// LWF Employees (screens LWF2–LWF2b) on the LWF API: GET employees/ (list,
// cards, paging) and GET employees/<employee_id>/ (the drawer). Read only.

// Card key on screen -> status sent to the server.
export const CARD_STATUS = { all: "ALL", covered: "COVERED", not_covered: "NOT_COVERED", held: "HELD", notsetup: "SITE_NOT_SET_UP" };

const upper = (value) => String(value || "").toUpperCase();
const amountOrNull = (value) => (value === null || value === undefined || value === "" ? null : Number(value));

// Screen key ("covered" / "not" / "held" / "notsetup") from the status codes.
export const statusKeyOf = (status, calculationStatus) => {
  const code = upper(status);
  const calc = upper(calculationStatus);
  if (code === "SITE_NOT_SET_UP" || calc === "SITE_NOT_SET_UP") return "notsetup";
  if (code.startsWith("HELD") || calc === "HELD_MISSING_DATA") return "held";
  if (code === "COVERED") return "covered";
  return "not";
};
const TONES = { covered: "green", not: "slate", held: "red", notsetup: "red" };

export const fromApiEmployee = (item = {}) => {
  const key = statusKeyOf(item.status, item.calculation_status);
  // Held / not set up: no amounts worked out yet ("—", not ₹0).
  const noAmounts = key === "held" || key === "notsetup";
  return {
    id: item.employee_id ?? item.id,
    emp_id: item.employee_code || "",
    name: item.name || "",
    department: typeof item.department === "object" ? item.department?.name || "" : item.department || "",
    site: item.site || null,
    site_name: item.site?.name || "",
    category: item.category || "",
    category_label: item.category || "—",
    lwf_wage: amountOrNull(item.lwf_wage),
    status: item.status,
    calculation_status: item.calculation_status,
    status_key: key,
    status_label: item.status_label || item.status || "",
    status_tone: TONES[key],
    next_deduction: item.next_deduction || "",
    next_label: item.next_deduction_label || "—",
    employee_amount: noAmounts ? null : amountOrNull(item.employee_amount),
    employer_amount: noAmounts ? null : amountOrNull(item.employer_amount),
  };
};

export const fetchLwfEmployees = async ({ domain, companyId, siteId, card = "all", search, page = 1, pageSize = 50, signal }) => {
  const data =
    (await lwfRequest({
      domain,
      path: "employees/",
      query: {
        company_id: companyId,
        site_id: siteId,
        status: CARD_STATUS[card] || "ALL",
        search: search || undefined,
        page,
        page_size: pageSize,
      },
      signal,
    })) || {};
  const results = Array.isArray(data) ? data : data.results || [];
  return {
    rows: results.map(fromApiEmployee),
    count: Number(data.count ?? results.length) || 0,
    cards: data.cards || {},
  };
};

// The drawer: the list row (employee) plus site, why, next deduction and
// history as the server sends them.
export const fetchLwfEmployee = async ({ domain, companyId, employeeId, signal }) => {
  const data = (await lwfRequest({ domain, path: `employees/${employeeId}/`, query: { company_id: companyId }, signal })) || {};
  return {
    ...data,
    row: fromApiEmployee(data.employee || {}),
    why: Array.isArray(data.why) ? data.why : [],
    history: Array.isArray(data.history) ? data.history : [],
  };
};
